export class AppConfig {
    public static config = {
        layout: 'vertical', // vertical, horizontal
        preLayout: null, // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-5h, nav-color, layout-6, layout-8
        collapseMenu: false,
        layoutType: 'menu-dark', // menu-dark, menu-light, dark
        navIconColor: true,
        headerBackColor: 'header-default', // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
        navBackColor: 'navbar-default', // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark,navbar-green, navbar-orange
        navBrandColor: 'brand-default', // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark, brand-green,brand-orange
        navBackImage: false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
        rtlLayout: false,
        navFixedLayout: true,
        headerFixedLayout: false,
        boxLayout: false,
        navDropdownIcon: 'style1', // style1, style2, style3
        navListIcon: 'style1', // style1, style2, style3, style4, style5, style6
        navActiveListColor: 'active-default', // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
        navListTitleColor: 'title-default', // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
        navListTitleHide: false,
        layout6Background: '#0066b3', // used only for preLayout = layout-6
        collapseNav: false,
    };
}

/* layout-6 background option*/
/* 1 - background color */
/*
#0066b3,#ff5252, #9575CD, #23b7e5, #424448
linear-gradient(to right, #00aeef 0%, #0066b3 100%)
linear-gradient(to right, #8ed1fc 0%, #0693e3 100%)
linear-gradient(to right, #4facfe 0%, #00f2fe 100%)
linear-gradient(to right, #667eea 0%, #764ba2 100%)
linear-gradient(to right, #f77062 0%, #fe5196 100%)
linear-gradient(to right, #9be15d 0%, #00e3ae 100%)
linear-gradient(to right, #b224ef 0%, #7579ff 100%)
linear-gradient(to right, #0acffe 0%, #495aff 100%)
linear-gradient(to right, #01a9ac 0%, #01dbdf 100%)
linear-gradient(to right, #fe5d70 0%, #fe909d 100%)
linear-gradient(to right, #0ac282 0%, #0df3a3 100%)
linear-gradient(to right, #fe9365 0%, #feb798 100%)
linear-gradient(to right, #A445B2 0%, #D41872 52%, #FF0066 100%)
*/

/* 2 - background image */
/*
url("assets/images/bg-images/bg1.jpg")
url("assets/images/bg-images/bg3.jpg")
url("assets/images/bg-images/bg4.jpg")
url("assets/images/bg-images/bg5.jpg")
*/

/* 3 - background pattern */
/*
url("assets/images/bg-images/1.png")
url("assets/images/bg-images/2.png")
url("assets/images/bg-images/3.png")
url("assets/images/bg-images/4.png")
url("assets/images/bg-images/5.png")
url("assets/images/bg-images/6.png")
*/
